module.exports = __webpack_public_path__ + "static/guusto-logo-8f0bdd89a9072db6c1af8c681afa5a57.png";